/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    // no-op.
  }


  installSourcePlanet (planet)
  {
    // no-op.
  }


};
